import React, { Component } from 'react';
import './VideoDashboard.scss';
import VideoListSearch from '../VideoListSearch.js';
import VideoTabs from '../VideoTabs/VideoTabs.js';
import 'plyr/dist/plyr.css';

class VideoDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
  }

  _handleSearchChanged = (searchText = '') => {
    this.setState({
      searchText,
    });
  };

  render() {
    const { searchText } = this.state;
    return (
      <div className="video-container">
        <section
          className="info-box"
          style={{
            height: 475,
            backgroundColor: 'var(--color-primary-500)',
          }}
        >
          <h1>Bite-sized training videos to learn how to address common use cases.</h1>
          <h3>
            Guides, tutorials and knowledge hub to help you learn, configure and use all Nexla
            products.
          </h3>
          <VideoListSearch
            onChange={this._handleSearchChanged}
            searchText={this.state.searchText}
          />
        </section>
        {/* Video Playlist */}
        <section className="video-playlist">
          <div className="playlist-tab">
            <VideoTabs searchText={searchText} />
          </div>
        </section>
      </div>
    );
  }
}

export default VideoDashboard;
